<!-- 课程管理模块 -->
<template>
    <!-- 刷卡记录表 -->
    <div class="buttonlist">
        <div class="buttonlist-m">
            <el-form :inline="true" :model="filteForm" class="demo-form-inline toolbar" style="padding-bottom: 0px"
                @submit.native.prevent>
                <el-form-item label="活动日期">
                    <el-date-picker v-model="dayStr" type="date" placeholder="请选择日期" value-format="yyyy-MM-dd"
                        format="yyyy-MM-dd"></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
                    <el-button type="warning" icon="el-icon-circle-plus-outline" @click="addActive">新增</el-button>
                </el-form-item>
            </el-form>
            <div v-loading="loading" element-loading-text="拼命加载中......">
                <el-table :data="tableData" style="width: 100%" :row-style="tableRowStyle"
                    :header-cell-style="tableHeaderColor">
                    <el-table-column prop="name" min-width="200" label="主题名称" align=center></el-table-column>
                    <el-table-column prop="courseDay" label="举办日期" align=center></el-table-column>
                    <el-table-column prop="type" label="类型" align=center :formatter="formatType"></el-table-column>
                    <el-table-column prop="location" label="位置" align=center></el-table-column>
                    <el-table-column prop="people" label="参加人数" align=center></el-table-column>
                    <el-table-column label="操作" width="210">
                        <template slot-scope="scope">
                            <el-button type="primary" size="mini" plain
                                @click="handleDetail(scope.$index, scope.row)">详情</el-button>
                            <el-button type="warning" size="mini" plain
                                @click="updateActive(scope.row)">修改</el-button>
                            <el-button type="danger" size="mini" plain
                                @click="handleDelete(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination background @current-change="handleCurrentChange" :current-page="pageNum"
                    layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize" align="center"
                    class="fenye"></el-pagination>
            </div>

            <el-dialog title="新增活动课程" :visible.sync="addActiveVisible" width="700px" :close-on-click-modal="false" center>
                <el-form :model="addForm" label-width="100px">
                    <el-form-item label="主题名称" prop="name">
                        <el-input v-model="addForm.name" auto-complete="off" :maxlength="30" style="width: 100%"></el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="活动时间" prop="describer">
                                <!-- <el-input v-model="addForm.courseDay" auto-complete="off" style="width: 100%"></el-input> -->
                                <el-date-picker
                                    v-model="addForm.courseDay"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="活动地点" prop="describer">
                                <el-input v-model="addForm.location" auto-complete="off" style="width: 100%"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="参加人数" prop="describer">
                                <el-input v-model="addForm.people" auto-complete="off" style="width: 100%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="活动描述" prop="describer">
                        <el-input v-model="addForm.describer" auto-complete="off" style="width: 100%" :rows="12"
                            type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="活动照片" prop="picture">
                        <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card"
                            :file-list="addFileList" :before-upload="beforeAvatarUploadPicB"
                            :http-request="uploadSectionFilePicB"
                            :on-remove="handleRemovePic" :limit="100">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="addActiveVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="addSubmit">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="修改活动课程" :visible.sync="editActiveVisible" width="700px" :close-on-click-modal="false" center>
                <el-form :model="addForm" label-width="100px">
                    <el-form-item label="主题名称" prop="name">
                        <el-input v-model="addForm.name" auto-complete="off" :maxlength="30" style="width: 100%"></el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="活动时间" prop="describer">
                                <!-- <el-input v-model="addForm.courseDay" auto-complete="off" style="width: 100%"></el-input> -->
                                <el-date-picker
                                    v-model="addForm.courseDay"
                                    type="date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    style="width: 100%">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="活动地点" prop="describer">
                                <el-input v-model="addForm.location" auto-complete="off" style="width: 100%"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="参加人数" prop="describer">
                                <el-input v-model="addForm.people" auto-complete="off" style="width: 100%"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="活动描述" prop="describer">
                        <el-input v-model="addForm.describer" auto-complete="off" style="width: 100%" :rows="12"
                            type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="活动照片" prop="picture">
                        <el-upload action="string" accept="image/png, image/jpeg" list-type="picture-card"
                            :file-list="addFileList" :before-upload="beforeAvatarUploadPicB"
                            :http-request="uploadSectionFilePicB"
                            :on-remove="handleRemovePic" :limit="100">
                            <i class="el-icon-plus"></i>
                        </el-upload>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click.native="editActiveVisible = false">取消</el-button>
                    <el-button type="primary" @click.native="editSubmit">确定</el-button>
                </div>
            </el-dialog>

            <el-dialog title="课程活动详情" style="margin-top:-12vh" :visible.sync="CourseVisible" width="700px" center>
                <el-form :model="showRow" label-width="100px">
                    <el-form-item label="主题名称" prop="name">
                        <el-input v-model="showRow.name" readonly auto-complete="off" style="width: 100%"></el-input>
                    </el-form-item>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item label="活动时间" prop="describer">
                                <el-input v-model="showRow.courseDay" auto-complete="off" style="width: 100%"
                                    readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="活动地点" prop="describer">
                                <el-input v-model="showRow.location" auto-complete="off" style="width: 100%"
                                    readonly></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="参加人数" prop="describer">
                                <el-input v-model="showRow.people" auto-complete="off" style="width: 100%"
                                    readonly></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="活动描述" prop="describer">
                        <el-input v-model="showRow.describer" auto-complete="off" style="width: 100%" readonly :rows="12"
                            type="textarea"></el-input>
                    </el-form-item>
                    <el-form-item label="活动照片" prop="picture">
                        <div>
                            <el-image :preview-src-list="showRow.picList" style="height: 100px"
                                v-for="item in showRow.imgList" :key="item.id" :src="item.src" />
                        </div>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button type="primary" @click.native="addActiveVisible = false">关闭</el-button>
                </div>
            </el-dialog>


        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            pageNum: 1, //页码
            pageSize: 10, //每页显示的条数
            totalDataNumber: 0,
            loading: true,
            dayStr: "",
            addActiveVisible: false,
            editActiveVisible: false,

            CourseVisible: false,
            showRow: {},
            addFileList: [],
            filteForm: {
                type: "",
                name: ""
            },
            tableData: [],
            typeList: [],
            addForm: {},
        };
    },
    methods: {
        handleDetail(index, row) {
            this.showRow = row;
            this.showRow.imgList = [];
            this.showRow.picList = [];
            if (row.picture != null) {
                let pics = row.picture.split(",");
                for (let i = 0; i < pics.length; i++) {
                    if(pics[i].length>20){
                        this.showRow.imgList.push({
                            id: i,
                            src: pics[i]
                        })
                        this.showRow.picList.push(pics[i]);
                    }
                }
            }
            this.CourseVisible = true;
        },
        beforeAvatarUploadPicB(file) {
            console.log(file);
            //this.outPicList.push(file);//获取值，用于删除时的比对  by guo 2020-6-30-16:10注释  换到下面判断才能添加
            let isPNG = false;
            let isImage = false;
            file.type == "image/gif" ? (isPNG = false) : (isPNG = true);
            isImage = file.type.match("image") != "image" ? false : true;
            const isLt2M = file.size / 1024 / 1024 < 2;
            if (!isImage) {
                this.$message.error("上传图片格式错误");
            }
            if (!isPNG) {
                this.$message.error("上传图片格式不能是 gif 格式");
            }
            if (!isLt2M) {
                this.$message.error("上传头像图片大小不能超过 2MB");
            }
            //by guo 2020-6-30-16:12添加判断  当所有验证通过之后才将该图片添加进数组中
            if (isPNG && isLt2M && isImage) {
                // this.addFileList.push(file);
            }
            return isPNG && isLt2M && isImage;
        },
        uploadSectionFilePicB(param) {
            console.log(param);
            var fileObj = param.file;
            if (fileObj != undefined) {
                // FormData 对象
                var form = new FormData();
                // 文件对象
                form.append("file", fileObj);
                form.append("fileType", "picture");
                form.append("bucketName", "cmny-oss");
                console.log(form);
                this.$postFormData("dmc/file/uploadFile", form).then(res => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({
                            type: "success",
                            message: res.message
                        });
                        this.addForm.pictureList.push({
                            sid: this.addForm.pictureList.length,
                            url: res.result
                        });
                        console.log(this.addForm.pictureList);
                    } else {
                        this.$message({
                            type: "error",
                            message: res.message
                        });
                    }
                });
            }
        },
        handleRemovePic(file, fileList) {
            console.log(file, fileList);
            //分两类删除  一类是还未提交上传基本信息的   二类是已经提交上传基本信息的
            if (file.status == "ready") {
                //删除的是一类
                for (let i = 0; i < this.addForm.pictureList.length; i++) {
                    console.log(this.addForm.pictureList[i]);
                    if (file.uid == this.addForm.pictureList[i].uid) {
                        this.addForm.pictureList.splice(i, 1);
                    }
                }
            } 
        },
        //点击查询
        onSubmit() {
            this.pageNum = 1;
            this.getTableData();
        },
        addActive() {
            this.addActiveVisible = true;
            this.addForm = {};
            this.addForm.pictureList = [];
        },
        handleDelete(row){
            this.$confirm("确认删除?", "提示", {
               type: "warning",
               closeOnClickModal: false,
               center:true
             })
               .then(() => {
                 var info = {
                   id: row.id
                 };
                 this.$postJson("omc/onlineCourse/delete", info).then(
                   res => {
                        this.getTableData();
                        this.$message.success("删除成功");
                   },
                   err => {
                     this.$message.error(err.message);
                   }
                 );
               });
        },
        updateActive(row) {
            this.editActiveVisible = true;
            this.addForm = Object.assign({}, row);
            this.addForm.pictureList = [];
            this.addFileList = [];
            this.addForm.picture.split(",").forEach((item,index) => {
                if(item.length>20){
                    this.addFileList.push({
                        uid: index,
                        url: item
                    })
                    this.addForm.pictureList.push({
                        sid: index,
                        url: item
                    });
                }
                
            });
        },
        editSubmit() {
            let pictures = '';
            console.log(this.addForm.pictureList);
            this.addForm.pictureList.forEach(item => {
                pictures += item.url + ',';
            });
            let params = {
                id: this.addForm.id,
                courseDay: this.addForm.courseDay,
                name: this.addForm.name,
                location: this.addForm.location,
                people: this.addForm.people,
                describer: this.addForm.describer,
                id: this.addForm.id,
                picture: pictures,
                startTime: this.addForm.courseDay,
                endTime: this.addForm.courseDay,
                type: 0
            };
            this.$postJson('omc/onlineCourse/update', params).then(res => {
                if (res.code == 200) {
                    this.getTableData();
                    this.editActiveVisible = false;
                }
            })
        },
        addSubmit() {
            let pictures = '';
            this.addForm.pictureList.forEach(item => {
                pictures += item.url + ',';
            });
            let params = {
                courseDay: this.addForm.courseDay,
                name: this.addForm.name,
                location: this.addForm.location,
                people: this.addForm.people,
                describer: this.addForm.describer,
                id: this.addForm.id,
                picture: pictures,
                startTime: this.addForm.courseDay,
                endTime: this.addForm.courseDay,
                type: 0
            };
            this.$postJson('omc/onlineCourse/add', params).then(res => {
                if (res.code == 200) {
                    this.getTableData();
                    this.addActiveVisible = false;
                }
               
            })

        },

        formatType(row) {
            if (row.type == 0) {
                return "线下活动";
            } else {
                return "线上课程";
            }
        },
        tableRowStyle({ row, rowIndex }) {
            if (rowIndex % 2 == 0) {
                return "background-color: #ffffff";
            } else {
                return "background-color: #e4f5f8";
            }
        },
        tableHeaderColor({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #d4f5fa;";
            }
        },
        //获取分页的紧急按钮数据  只获取pageSize条数据
        getTableData() {
            let params = {
                pageSize: this.pageSize,
                pageNum: this.pageNum,
                dayStr: this.dayStr
            };
            this.loading = true;
            this.$postJson('omc/onlineCourse/select', params).then(res => {
                if (res.code == 200) {
                    this.totalDataNumber = Number(res.result.total)
                    this.tableData = res.result.list;
                }
                this.loading = false;
            })
        },
        handleCurrentChange(val) {
            this.pageNum = val;
            this.getTableData();
        },
    },
    mounted() {
        this.getTableData();
    },
    created() {
        this.groupId = sessionStorage.getItem("groupId");
    },
};
</script>
<style lang="scss" scoped>
.buttonlist {
    .buttonlist-m {
        padding: 10px 0 0 5px;
    }
}

.fenye {
    margin: 0;
    padding: 30px 0;
    background: #fff;
}
</style>
